site.owlRange = {
	owl: $('#front-categories'),
	items: $('#front-categories').find('.item').length,
	sliderId: '#owl-range-slider',

	init: function () {
		// Must be attached before initialization
		site.owlRange.owl.on('initialized.owl.carousel resized.owl.carousel', function (e) {
			site.owlRange.updateSlider(e);
		});

		// Update value of slider if current item changes
		site.owlRange.owl.on('changed.owl.carousel', function (e) {
			site.owlRange.updateSliderValue(e);
		});

		site.owl.init(site.owlRange.owl, {
			loop: false,
			nav: false,
			callbacks: true,
			responsive: {
				0: {
					items: Math.min(1, site.owlRange.items)
				},
				600: {
					items: Math.min(3, site.owlRange.items)
				},
				1000: {
					items: Math.min(4, site.owlRange.items)
				},
				1300: {
					items: Math.min(5, site.owlRange.items)
				},
				1500: {
					items: Math.min(6, site.owlRange.items)
				}
			}
		});
	},

	updateSlider: function (event) {
		$(site.owlRange.sliderId).remove();
		if (event.item.count > event.page.size) {
			site.owlRange.owl.append(site.owlRange.getSlider(event));
			$(site.owlRange.sliderId).on('input', function (event) {
				$(site.owlRange.owl).trigger('to.owl.carousel', [$(this).val(), 800, true]);
			});
		}
	},

	updateSliderValue: function (event) {
		$(site.owlRange.sliderId).val(event.item.index);
	},

	getSlider: function (event) {
		var slider = '<input id="owl-range-slider" value="0" type="range" min="0" max="' + (event.item.count - event.page.size) + '"/>';
		return '<div class="slider-wrap">' + slider + '</div>';
	}

};

site.inits.push('site.owlRange.init()');